import { IConfig } from '@cian/config/shared';

const PRIVACY_POLICY_CONFIG_KEY = 'callback-widget.privacyPolicyUrl';

export const getPrivacyPolicyUrl = (config: IConfig) => {
  return config.get<string>(PRIVACY_POLICY_CONFIG_KEY);
};
